/* eslint-disable @typescript-eslint/no-explicit-any */

import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { cn } from "@/lib/utils";
import { useDocument, useDocumentReadOnly } from "../hook/useDocument";
import { DocumentTableForm } from "./document-table-form";
import { useState } from "react";
import { IfElseChain } from "@/components/shared/If-else-chain";
import { ItemMasterSelect } from "./item-master-select";
import { DocumentAddressSelect } from "./document-address-select";
// import { IsSimilarityMatch } from "./is-similarity-match";

type DocumentTableCellProp = {
  data: any;
  keyValue: string;
  parentKey?: string;
  isHeader?: boolean;
  className?: string;
  textType?: string;
  mappingKey?: string;
  is_similarity_match?: string;
};
export const DocumentTableCell = ({
  data,
  isHeader,
  parentKey,
  textType,
  mappingKey = "",
  keyValue,
  is_similarity_match,
}: DocumentTableCellProp) => {
  const [state, setState] = useDocument();
  const isReadOnly = useDocumentReadOnly();
  const [active, setActive] = useState(false);

  const currentKey = mappingKey.replace("detailsData.domain_json.", "");
  const temp1 = state.detailsData?.api_calls?.find((prop: any) =>
    Object.keys(prop).includes(currentKey.replace(".text", "")),
  );

  const currentDropDownInfo: any = temp1
    ? { key: Object.keys(temp1)[0], value: Object.values(temp1)[0] }
    : null;

  return (
    <div
      className={cn(
        "table-cell text-[14px] min-w-[200px]",
        isHeader
          ? "table-cell bg-gray-100 font-semibold relative"
          : "outline-buttonColor relative text-[rgb(71,85,105)] py-4",
        textType === "text"
          ? "min-h-[40px] p-0 w-full flex items-center"
          : "px-3 py-2",
        textType === "text" && !active ? "px-3" : "",
        state.isEditMode ? " " : "",
      )}
    >
      <IfElseChain
        conditions={[
          [
            currentDropDownInfo ? true : false,
            <>
              {currentDropDownInfo?.value?.includes("item_master") ||
              currentDropDownInfo?.value?.includes("erp_sku") ? (
                <>
                  <ConditionRenderer condition={active}>
                    <DocumentTableForm
                      value={data}
                      onBlur={() => setActive(false)}
                      textType={textType}
                      onChange={(prop: any) =>
                        setState({
                          type: "update-data",
                          data: {
                            key: parentKey,
                            value: prop,
                          },
                        })
                      }
                    />
                    <div
                      // onClick={() => setActive(true)}
                      className="min-h-5 w-full"
                    >
                      <ItemMasterSelect
                        keyValue={keyValue}
                        data={data}
                        parentKey={parentKey}
                        endPoint={currentDropDownInfo}
                        setEditActive={setActive}
                        is_similarity_match={is_similarity_match}
                      />
                    </div>
                  </ConditionRenderer>
                </>
              ) : (
                <div
                  onClick={() => !isReadOnly && setActive(true)}
                  className="min-h-5 w-full"
                >
                  <DocumentAddressSelect
                    keyValue={keyValue}
                    data={data}
                    parentKey={parentKey}
                    endPoint={currentDropDownInfo}
                    is_similarity_match={is_similarity_match}
                  />
                </div>
              )}
            </>,
          ],
          [
            true,
            <ConditionRenderer condition={isHeader ? true : false}>
              {data}
              <ConditionRenderer condition={active}>
                <DocumentTableForm
                  value={data}
                  onBlur={() => setActive(false)}
                  textType={textType}
                  onChange={(prop: any) =>
                    setState({
                      type: "update-data",
                      data: {
                        key: parentKey,
                        value: prop,
                      },
                    })
                  }
                />
                <div
                  onClick={() => !isReadOnly && setActive(true)}
                  className="min-h-5 w-full"
                >
                  {data}{" "}
                </div>
              </ConditionRenderer>
            </ConditionRenderer>,
          ],
        ]}
      />
    </div>
  );
};
